import { Component, ViewChild, HostListener, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FormGroup, Validators, FormBuilder, FormArray } from "@angular/forms";
import { ISecurityGroup, ISecurityGroupUser } from "../../../interfaces/isecuritygroup";
import { ToastrService } from "ngx-toastr";
import { SecurityGroupService } from "../../../services/securitygroup.service";

import { ActivatedRoute, Router, RouterModule } from "@angular/router";

import { ICanComponentDeactivate } from "../../../interfaces/icancomponentdeactivate";
import { Observable } from "rxjs";
import { ConfirmationModalComponent } from "../../confirmationmodal/confirmationmodal.component";
import { UserSearchModalComponent } from "../../usersearchmodal/usersearchmodal.component";
import { HeaderComponent } from "../../header/header.component";

@Component({
    selector: "securitygroup",
    templateUrl: "./securitygroup.component.html",
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, ConfirmationModalComponent, UserSearchModalComponent, HeaderComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class SecurityGroupComponent implements ICanComponentDeactivate {
    securityGroupForm: FormGroup;
    securityGroup: ISecurityGroup;
    title: string;
    @ViewChild("confirmModal") confirmModal;
    constructor(activatedRoute: ActivatedRoute,
        private router:Router,
        private toastsManager: ToastrService,
        private securityGroupService: SecurityGroupService,
        private fb: FormBuilder) {
        this.securityGroup = activatedRoute.snapshot.data["securityGroup"];
        const users: FormArray = this.fb.array([]);
        if (this.securityGroup != null && this.securityGroup.users != null) {
            this.securityGroup.users.forEach((e: ISecurityGroupUser) => {
                users.push(this.fb.group({
                    id: e.id,
                    name: e.name,
                    email: e.email
                }));
            });
        } else {
            this.securityGroup = { users: new Array<ISecurityGroupUser>(), disabled: false, id: null, name: null} as ISecurityGroup;
        }

        this.securityGroupForm = this.fb.group({
            id: [this.securityGroup.id != null ? this.securityGroup.id : null],
            name: [this.securityGroup.name, Validators.required],
            disabled: [this.securityGroup.disabled, Validators.required],
            users: users
        });
        this.title = this.securityGroup.id != null
            ? "Edit security group"
            : "Create security group";
    }

    /**
     * saves the security group
     * @param securityGroup security group being created/edited
     * @param formValid determines if the form is valid or not
     */
    saveSecurityGroup(securityGroup: ISecurityGroup, formValid: boolean): void {
        if(formValid) {
            if(!this.securityGroupForm.controls["id"].value) {
                this.securityGroupService.create(securityGroup).subscribe((id: number) => {
                    this.securityGroupForm.controls["id"].setValue(id);
                    this.toastsManager.success("Security group created successfully");
                    this.securityGroup.id = id;
                    this.securityGroupForm.reset();
                    this.router.navigate(["/securitygroups/list"]);
                });
            } else {
                this.securityGroupService.update(securityGroup).subscribe(() => {
                    this.toastsManager.success("Security group updated successfully");
                    this.securityGroupForm.reset();
                    this.router.navigate(["/securitygroups/list"]);
                });
            }
        } else {
            this.toastsManager.error("Please correct form errors before continuing");
        }
    }

    removeUser(index: number): void {
        const control: FormArray = <FormArray>this.securityGroupForm.controls["users"];
        control.removeAt(index);
        this.securityGroup.users.splice(index, 1);
    }

    usersSelected(users: any): void {
        const control: FormArray = <FormArray>this.securityGroupForm.controls["users"];
        
        users.forEach((user: any) => {
            if (user.hasOwnProperty("userId")) {
                // Check if user is already in the form array to prevent duplicates
                const existingUser = control.controls.find(ctrl => 
                    ctrl.get('id')?.value === user.userId
                );
                
                if (!existingUser) {
                    control.push(this.fb.group({
                        id: user.userId,
                        name: user.name,
                        email: user.email
                    }));
                    
                    // Also add to the securityGroup.users array if it doesn't exist
                    const existingInArray = this.securityGroup.users.find(u => u.id === user.userId);
                    if (!existingInArray) {
                        this.securityGroup.users.push({
                            id: user.userId,
                            name: user.name,
                            email: user.email
                        });
                    }
                }
            }
        });
    }

    @HostListener("window:beforeunload")
    canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
        if (this.securityGroupForm.dirty) {
            this.confirmModal.openModal();
            return false;
        } else {
            return true;
        }
    }
    onAccept(): void {
        // reset the the original back to whats currenlty in itemConfigSet, this allows to pass check  in candeactivate
        this.securityGroupForm.reset();
        this.router.navigate([this.navigatingTo]);
        this.confirmModal.closeModal();
    }

    onDecline(): void {
        this.confirmModal.closeModal();
    }

    getUsersFormArray(): FormArray {
        return this.securityGroupForm.get('users') as FormArray;
    }

    navigatingTo: string;
}


